export default __webpack_public_path__ + "static/media/btn_character_alignment_center.044f67d4.svg";